//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { recommendGoods, searchGoods, hotSearch } from "@/api/goodsSearch"
import { getSearchDefault } from "@/api/index.js"
export default {
  data() {
    return {
      goodName: "", //搜索的商品名称
      searchName: "", //搜索的商品名称
      pageNo: 1, //页数
      lastPageNo: 0, //最后一页
      nextPageNo: 0, //下一页
      goodList: [], //搜索到的商品列表
      showNoPage: false, //无结果是否显示
      allSearchList: [], //大家都在搜列表
      recommendGoodsList: [], //本周好物商品列表
      searchNameList: [], //最近搜索的商品名称列表
      showSearch: false, //是否显示搜索信息
      showsearchName: false, //是否显示最近搜索
      showBottom: false, //是否显示底线
      hotSearchName: [],
      showHotSearch: true
    };
  },

  components: {},

  computed: {},

  created() {
    let nameList = JSON.parse(localStorage.getItem('searchNameList'));
    if(nameList == null || nameList == undefined || nameList.length <= 0){
        //默认设置 七夕  玫瑰  搜索内容
        localStorage.setItem('searchNameList', JSON.stringify(this.searchNameList));
    }

    //从本地缓存获取最近搜索数据
    this.goodNameGetStorageSync();
    console.log("searchNameList----", this.searchNameList)
    this.recommendGoodsListFun(); //本周好物列表
    this.getHotSearch()
    
    this.getSearchDefaultFun();//获取搜索词默认词和本周限购
  },

  mounted() {},

  methods: {
    recommendGoodsListFun() {
      recommendGoods().then(res=>{
        if(res.status == 1){
          console.log(res)
          this.recommendGoodsList = res.result
          // let goodList = res.result;
				  // this.goodList = this.goodList.concat(goodList)
          // if (this.goodList.length <= 0) {
          //   this.showNoPage = true;
          //   } else {
          //   this.showNoPage = false;
          // }
        }
      })
    },
    //获取搜索词默认词和本周限购
    getSearchDefaultFun() {
      let that = this;
      getSearchDefault().then(res=>{
        if(res.status == 1){
          that.goodName = res.result.default1;
        }
        that.searchGoodFun();
      })
    },
    //获取热搜
    getHotSearch(){
      hotSearch().then(res=> {
        if(res.status==1){
          if(res.result != null){
            this.hotSearchName = res.result.split(',')
          }
        }
      })
    },

    //大家都在搜  查询数据
      allSearchGetGoodfun: function(goodName) {
        this.goodName = goodName;
        this.goodList = [];
        this.pageNo = 1;
        //查询数据
        this.searchGoodListFun();
      },
    //搜索商品
    searchGoodListFun: function() {
      //每次搜索商品
      var that = this;
      that.searchName = that.goodName;
      var params = {
        goodsName: that.goodName,
        pageNo: that.pageNo,
        pageSize: 8
      }
      //提示搜索中
      //请求数据
      searchGoods(params).then(res=> {
        if(res.status == 1){
          console.log("res---------", res)
          let goodList = that.goodList;
            let newGoodList = goodList.concat(res.result.result)
            //设置搜索出的商品列表
            that.goodList = newGoodList;
            that.showSearch = false; //隐藏搜索内容
            that.showHotSearch = false; //隐藏热搜
            that.nextPageNo = res.result.nextPageNo;
            that.lastPageNo = res.result.lastPageNo;
            that.currentPageNo = res.result.currentPageNo;
            console.log("goodList---------", that.goodList)
            //如果没有数据显示无结果
            if (that.goodList.length <= 0) {
              that.showNoPage = true;
            } else {
              that.showNoPage = false;
            }
            //如果当前页等于最后一页，显示底线
            if (res.result.currentPageNo == res.result.lastPageNo) {
              that.showBottom = true;
            } else {
              that.showBottom = false;
            }
        }
      })
    },


    //搜索内容存到本地缓存
    goodNameSetStorageSync: function() {
      let nameList = JSON.parse(localStorage.getItem('searchNameList'))
      if (nameList && nameList.length > 0) {
        //判断是否存在这个值
        let inNum = 0; //是否包含搜索内容
        for (let item in nameList) {
          console.log("item---", item)
          console.log("this.goodName---", this.goodName)
          if (nameList[item] == this.goodName) {
            inNum++;
          }
        }
        //缓存数据最多存储三个
        if (nameList.length >= 3) {
          nameList.pop();
          //七夕节 只删除第三个, 永久保留  七夕  玫瑰
        }
        //如果不包含搜索，加入到本地缓存
        if (inNum <= 0) {
          // nameList.splice(0,0,this.goodName);
          //七夕改为从后面添加
          nameList.push(this.goodName)
        }

      } else {
        nameList = [];
        nameList.push(this.goodName)
      }
      localStorage.setItem('searchNameList', JSON.stringify(nameList))
    },
    goodNameGetStorageSync: function() {
      //从本地缓存获取最近搜索数据
      let nameList = JSON.parse(localStorage.getItem('searchNameList'))
      //如果本地缓存有数据
      if (nameList && nameList.length > 0) {
        this.showSearch = true;
        this.searchNameList = nameList;
      }else{
        this.showSearch = false;
        this.searchNameList = [];
      }
    },
    cleargoodNameStorageSync() {
      //提示清理成功
      localStorage.removeItem("searchNameList");

      // this.showsearchName = false;
      this.showSearch = false
      this.searchNameList = [];
    },
    //输入框搜索
    searchGoodFun: function() {
      //清空数据列表
      this.goodList = [];
      if (this.goodName.trim().length > 0) {
        this.goodNameSetStorageSync(); //搜索内容存入缓存
        this.searchGoodListFun(); //搜索商品
      }
    },

      // 输入框改变数据
      inputChangeFun: function (event) {
        if (this.goodName.trim().length <= 0) {
          //从本地缓存获取最近搜索数据
        this.goodNameGetStorageSync();
        this.showSearch = true;//显示搜索信息
        this.showsearchName = true;//显示最近搜索
        this.showNoPage = false;//隐藏没有搜索结果
        }
      },

    //清理搜索内容
    clearInputValueFun: function() {
      this.goodName = "";
      //从本地缓存获取最近搜索数据
      this.showSearch = true; //显示搜索信息
      this.showsearchName = true; //显示最近搜索
      this.showNoPage = false; //隐藏没有搜索结果
      this.showHotSearch = true;
      this.goodNameGetStorageSync();
    },

    //跳转到商品详情
    gotoProductFun: function(goodsItem) {
      window.location.href = process.env.PAGEURL + "/goodDetails?gid=" + goodsItem.goodsCode + "&utm_source=search";
    },

    //加载更多
    moreListFun: function() {
      var pageNo = this.pageNo;
      if (this.nextPageNo >= 1 && this.currentPageNo < this.lastPageNo) {
        this.pageNo = pageNo + 1;
        //获取订单列表
        this.searchGoodListFun()
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/view/goodsSearch/goodsSearch.vue